import { CoverageRow } from '../types/comparedPlans';
import { HERO_ICON, ICON_USER } from './assets';
import { publicAsset } from './publicAsset';

export const headerLogoColor = 'color';
export const headerLogoWhite = 'white';
export const cheapestPlan = 0.47;
export const summaryStepCat = publicAsset('/summary-step-cat.jpg');
export const personalInfoStepCat = publicAsset('/icon-personal-info-cat.png');
export const hiringStepCat = publicAsset('/icon-hiring-cat.jpg');

export const headerDefaultHeightDesktop = 80; // By UI/UX designs
export const headerDefaultHeightMobile = 64; // By UI/UX designs

export const breakPointXl = 1200;
export const breakPointLg = 992;
export const breakPointMd = 768;
export const breakPointSm = 576;

export const TypeVariant = {
  withoutCharges: 'Sin cargas',
  withCharges: 'Con cargas',
  withTwoOrMoreCharges: 'Con 2 o más cargas',
};

export const TypeCoverage = {
  dental: 'dental',
  catastrophic: 'catastrophic',
  decease: 'decease',
} as const;

// Wizard Steps
export const wizardUserAndCompanyStep = 'UserAndCompany';
export const wizardEmailStep = 'email';
// Active Wizard Steps
export const wizardWorkersStep = 'workers';
export const wizardQuoterStep = 'quote';

// Deprecated Wizard Steps
export const wizardCoveragesStep = 'coverages';
export const wizardVariantsStep = 'variants';
export const wizardSummaryStep = 'summary';
export const wizardFormStep = 'form';
export const wizardPersonalInfoStep = 'personalInfo';
export const wizardPlansStep = 'plans';

// Progress Panel Modals
export const PanelModals = {
  hiringSumaryModals: {
    availablePlan: 'plan',
  },
  hiringStepsModals: {
    companyName: 'company-name',
    shareIncorporation: 'share',
    advertise: 'company-advertise',
  },
  hiringCompanyModals: {
    company: 'company',
    admin: 'admin',
  },
  hiringIncorporationsModals: {
    charges: 'charges',
  },
};

// RegEx
export const regExpOnlyNumbers = /^\d+$/;
export const regExpRut = /[0-9kK.-]/;
export const regExpAlphabetic = /[a-zA-Z'&\u00f1\u00d1 ]+/;
export const regExpAlphanumeric = /[a-zA-Z0-9\u00f1\u00d1 ]+/;
export const regExpAlphanumericSpecialCharacters = /[a-zA-Z0-9À-ÿ'&\u00f1\u00d1\u0023 ]+/;
export const regExpSpecialCharacters = /[\s\S]/;
export const regExpPositiveIntegers = /(\D+)/g;
export const regExpDate = /[0-9/]/;
export const regExpUpperCaseNames = /(^\w{1})/g;
export const regExpAccents = /[\u0300-\u036f]/g;
export const regExpLettersAccents = /[À-ÿ]+/;
export const regExpNumberTextfieldPattern = '[0-9]*';
export const regExpCompanyName =
  /^[a-zA-Z0-9ÑñÁáÉéÍíÓóÚú&.](?:[a-zA-Z0-9ÑñÁáÉéÍíÓóÚú&. '\-]{0,248}[a-zA-Z0-9ÑñÁáÉéÍíÓóÚú&.])?$/;
export const regExpInvalidCompanyName = /[^a-zA-Z0-9ÑñÁáÉéÍíÓóÚú&. '\-]/g;

// Delay
export const delayLoader = 2000;
export const delayReviewAmount = 1000;
export const delayToaster = 4000;
export const delayPlanUpgrade = 5000;
export const delayPageLoader = 1000;
export const delayEstimateSteps = 3000;

export const coveragesKeys = {
  health: 'health',
  life: 'life',
  dental: 'dental',
  catastrophic: 'catastrophic',
};

export const coveragesTexts: any = {
  health: 'Salud',
  life: 'Vida',
  dental: 'Dental',
  catastrophic: 'Catastrófico',
  decease: 'Deceso',
};

export const maxLengthWorkers = 4;
export const maxLengthRut = 9;
export const bicevidaURL = 'https://www.bicevida.cl/';

export const fontsObservedDelay = 15000;

export const asyncHideClass = 'async-hide';

export const preleadStatus = {
  EMPTY: 'EMPTY',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
};

export const bicevidaURLBenefits = 'https://circulo.bicevida.cl/';
export const bicevidaURLDentalBenefits = 'https://circulo.bicevida.cl/beneficio/cam-dental';
export const bicevidaURLHealthBenefits = 'https://beneficios.beliv.cl';
export const bicevidaURLPartnersBenefits = 'https://www.bicevida.cl/prestadores-preferentes/';
export const bicevidaURLWindowBenefits = 'https://www.bicevida.cl/ventanilla-unica/';

export const bicevidaURLWindowIndividualInsurance =
  'https://segurocomplementariosalud.bicevida.cl/?utm_source=bicevida&utm_medium=referral&utm_campaign=pyme-modal/';

export const benefitsListURL = 'https://www.bicevida.cl/beneficios/';
export const summaryBannerBg = publicAsset('/summary-banner-wave.svg');
export const imgSaveMoney = publicAsset('/savemoney.png');
export const imgChooseInsurance = publicAsset('/choose_insurance.png');
export const imgJubilolos = publicAsset('/jubilolos.png');
export const minLimitWorkers = 5;

export const footerHeightSize = 80;
export const optionsHeightSize = 40;
export const spacingHeightSize = 50;
export const maxHeightSize = 240;

export const dateSelectInitialDate = new Date().getFullYear();
export const dateSelectLeftArrow = '\u276E';
export const dateSelectRightArrow = '\u276F';
export const unicode = 'NFD';
export const bankStateOfChile = 'Banco Estado';
export const accountRut = 'Cuenta Rut';
export const accountVista = 'Cuenta Vista';
export const fonasa = 'Fonasa';

export const genderOptions = { Masculino: 'M', Femenino: 'F' };
export const genderOptionsTexts = { man: 'M', woman: 'F' };
export const spouseText = 'Cónyuge/Conviviente civil';

export const relationshipList = ['Cónyuge/Conviviente civil', 'Hija', 'Hijo'];
export const beneficiaryRelationshipList = [
  { name: 'Hijo/a', code: 1 },
  { name: 'Cónyuge', code: 2 },
  { name: 'Padre', code: 3 },
  { name: 'Madre', code: 4 },
  { name: 'Hermano/a', code: 5 },
  { name: 'Abuelo/a', code: 6 },
  { name: 'Nieto/a', code: 7 },
  { name: 'Tío/a', code: 8 },
  { name: 'Primo/a', code: 9 },
  { name: 'Otro', code: 10 },
];
export const relationshipListTexts = {
  spouse: 'Cónyuge/Conviviente civil',
  daugther: 'Hija',
  son: 'Hijo',
};

export const rangeValidations = {
  incorporation: {
    max: { years: 18, days: 0 },
    min: { years: 71, days: 1 },
  },
  spouse: {
    max: { years: 18, days: 0 },
    min: { years: 71, days: 1 },
  },
  otherRelatives: {
    max: { years: 0, days: 14 },
    min: { years: 23, days: 364 },
  },
  entryDateToCompany: {
    max: { years: 0, days: 0 },
    min: { years: 100, days: 0 },
  },
};

export const healthSystemList = [
  { title: 'Fonasa', code: 1 },
  { title: 'Banmédica', code: 9 },
  { title: 'Capredena', code: 24 },
  { title: 'Chuquicamata', code: 33 },
  { title: 'Colmena Golden Cross', code: 3 },
  { title: 'Consalud', code: 4 },
  { title: 'Cruz Blanca', code: 6 },
  { title: 'Cruz del Norte', code: 34 },
  { title: 'Dipreca', code: 37 },
  { title: 'Esencial', code: 42 },
  { title: 'Fundación', code: 20 },
  { title: 'Ferrosalud', code: 30 },
  { title: 'Fusat', code: 28 },
  { title: 'Nueva Masvida', code: 15 },
  { title: 'Río Blanco', code: 46 },
  { title: 'San Lorenzo', code: 22 },
  { title: 'Sisan', code: 35 },
  { title: 'Vida Tres', code: 7 },
];
export const riskyActivitiesCardIcon = publicAsset('/risky-sport-card-icon.jpg');
export const medicalInfoCardIcon = publicAsset('/icon-medical-info-card.jpg');
export const familyMemberWife = publicAsset('/family-group-wife-card-icon.jpg');
export const familyMemberHusband = publicAsset('/family-group-husband-card-icon.jpg');
export const familyMemberDaugther = publicAsset('/family-group-daugther-card-icon.jpg');
export const familyMemberSon = publicAsset('/family-group-son-card-icon.jpg');
export const familyMemberGenericParent = publicAsset('/family-group-generic-card-icon.jpg');
export const beneficiariesIcon = publicAsset('/beneficiaries-card.icon.jpg');

export const maxDiseaseYears = 65;

export const maxLengthNumberAccount = 20;

export const incorporationSectionStatus: any = {
  pending: 'pending',
  blocked: 'blocked',
  valid: 'valid',
};
export const incorporationSectionIcons: any = {
  pending: null,
  blocked: 'https',
  valid: 'check',
  close: 'remove',
  open: 'add',
};

export const currentYear = new Date().getFullYear();
export const minYearBeneficiaries = new Date().getFullYear() - 17;

export const dayOfMonth = 31;
export const monthOfYear = 12;

export const incorporationStatus = {
  SENT: 'OUT_FOR_SIGNATURE',
  SIGNED: 'SIGNED',
  IN_PROCESS: 'IN_PROCESS',
  HIRED: 'HIRED',
};

export const incorporationStatusTexts: any = {
  IN_PROCESS: 'En proceso',
  OUT_FOR_SIGNATURE: 'Por firmar',
  SIGNED: 'Firmado',
  HIRED: 'Cerrado',
};

export const incorporationListInfo: any = {
  IN_PROCESS: {
    class: 'yellow',
    percentage: 30,
  },
  OUT_FOR_SIGNATURE: {
    class: 'blue',
    percentage: 70,
  },
  SIGNED: {
    class: 'green',
    percentage: 100,
  },
  HIRED: {
    class: 'green',
    percentage: 100,
  },
};

enum ProgressEnumColor {
  YELLOW = 'yellow',
  BLUE = 'blue',
  GREEN = 'green',
}

export const leadStatusProgress = {
  CREATED: {
    class: ProgressEnumColor.YELLOW,
    label: 'Creado',
    type: 'IN_PROCESS',
  },
  IN_PROCESS: {
    class: ProgressEnumColor.YELLOW,
    label: 'En proceso',
    type: 'IN_PROCESS',
  },
  HIRING: {
    class: ProgressEnumColor.BLUE,
    label: 'Contratación',
    type: 'HIRING',
  },
  SIGNED: {
    class: ProgressEnumColor.BLUE,
    label: 'Firmado',
    type: 'SIGNED',
  },
  HIRED: {
    class: ProgressEnumColor.GREEN,
    label: 'Cerrado',
    type: 'HIRED',
  },
};

export const districtsByRegion: any = {
  'Región Metropolitana de Santiago': [
    'Alhué',
    'Buin',
    'Calera de Tango',
    'Cerrillos',
    'Cerro Navia',
    'Colina',
    'Conchalí',
    'Curacaví',
    'El Bosque',
    'El Monte',
    'Estación Central',
    'Huechuraba',
    'Independencia',
    'Isla de Maipo',
    'La Cisterna',
    'La Florida',
    'La Granja',
    'La Pintana',
    'La Reina',
    'Lampa',
    'Las Condes',
    'Lo Barnechea',
    'Lo Espejo',
    'Lo Prado',
    'Macul',
    'Maipú',
    'María Pinto',
    'Melipilla',
    'Ñuñoa',
    'Padre Hurtado',
    'Paine',
    'Pedro Aguirre Cerda',
    'Peñaflor',
    'Peñalolén',
    'Pirque',
    'Providencia',
    'Pudahuel',
    'Puente Alto',
    'Quilicura',
    'Quinta Normal',
    'Recoleta',
    'Renca',
    'San Bernardo',
    'San Joaquín',
    'San José de Maipo',
    'San Miguel',
    'San Pedro',
    'San Ramón',
    'Santiago',
    'Talagante',
    'Til Til',
    'Vitacura',
  ],
  'Región de Antofagasta': [
    'Antofagasta',
    'Calama',
    'María Elena',
    'Mejillones',
    'Ollagüe',
    'San Pedro de Atacama',
    'Sierra Gorda',
    'Taltal',
    'Tocopilla',
  ],
  'Región de Arica y Parinacota': ['Arica', 'Camarones', 'General Lagos', 'Putre'],
  'Región de Atacama': [
    'Alto del Carmen',
    'Caldera',
    'Chañaral',
    'Copiapó',
    'Diego de Almagro',
    'Freirina',
    'Huasco',
    'Tierra Amarilla',
    'Vallenar',
  ],
  'Región de Aysén del General Carlos Ibáñez del Campo': [
    'Aysén',
    'Chile Chico',
    'Cisnes',
    'Cochrane',
    'Coyhaique',
    'Guaitecas',
    'Lago Verde',
    "O'Higgins",
    'Río Ibáñez',
    'Tortel',
  ],
  'Región de Coquimbo': [
    'Andacollo',
    'Canela',
    'Combarbalá',
    'Coquimbo',
    'Illapel',
    'La Higuera',
    'La Serena',
    'Los Vilos',
    'Monte Patria',
    'Ovalle',
    'Paihuano',
    'Punitaqui',
    'Río Hurtado',
    'Salamanca',
    'Vicuña',
  ],
  'Región de La Araucanía': [
    'Angol',
    'Carahue',
    'Cholchol',
    'Collipulli',
    'Cunco',
    'Curacautín',
    'Curarrehue',
    'Ercilla',
    'Freire',
    'Galvarino',
    'Gorbea',
    'Lautaro',
    'Loncoche',
    'Lonquimay',
    'Los Sauces',
    'Lumaco',
    'Melipeuco',
    'Nueva Imperial',
    'Padre Las Casas',
    'Perquenco',
    'Pitrufquén',
    'Pucón',
    'Purén',
    'Renaico',
    'Saavedra',
    'Temuco',
    'Teodoro Schmidt',
    'Toltén',
    'Traiguén',
    'Victoria',
    'Vilcún',
    'Villarrica',
  ],
  'Región de Los Lagos': [
    'Ancud',
    'Calbuco',
    'Castro',
    'Chaitén',
    'Chonchi',
    'Cochamó',
    'Curaco de Vélez',
    'Dalcahue',
    'Fresia',
    'Frutillar',
    'Futaleufú',
    'Hualaihué',
    'Llanquihue',
    'Los Muermos',
    'Maullín',
    'Osorno',
    'Palena',
    'Puerto Montt',
    'Puerto Octay',
    'Puerto Varas',
    'Puqueldón',
    'Purranque',
    'Puyehue',
    'Queilén',
    'Quellón',
    'Quemchi',
    'Quinchao',
    'Río Negro',
    'San Juan de la Costa',
    'San Pablo',
  ],
  'Región de Los Ríos': [
    'Corral',
    'Futrono',
    'La Unión',
    'Lago Ranco',
    'Lanco',
    'Los Lagos',
    'Máfil',
    'Mariquina',
    'Paillaco',
    'Panguipulli',
    'Río Bueno',
    'Valdivia',
  ],
  'Región de Magallanes y de la Antártica Chilena': [
    'Antártica',
    'Cabo de Hornos',
    'Laguna Blanca',
    'Natales',
    'Porvenir',
    'Primavera',
    'Punta Arenas',
    'Río Verde',
    'San Gregorio',
    'Timaukel',
    'Torres del Paine',
  ],
  'Región de Ñuble': [
    'Bulnes',
    'Chillán',
    'Chillán Viejo',
    'Cobquecura',
    'Coelemu',
    'Coihueco',
    'El Carmen',
    'Ñiquén',
    'Ninhue',
    'Pemuco',
    'Pinto',
    'Portezuelo',
    'Quillón',
    'Quirihue',
    'Ránquil',
    'San Carlos',
    'San Fabián',
    'San Ignacio',
    'San Nicolás',
    'Treguaco',
    'Yungay',
  ],
  'Región de Tarapacá': [
    'Alto Hospicio',
    'Camiña',
    'Colchane',
    'Huara',
    'Iquique',
    'Pica',
    'Pozo Almonte',
  ],
  'Región de Valparaíso': [
    'Algarrobo',
    'Cabildo',
    'Calle Larga',
    'Cartagena',
    'Casablanca',
    'Catemu',
    'Concón',
    'El Quisco',
    'El Tabo',
    'Hijuelas',
    'Isla de Pascua',
    'Juan Fernández',
    'La Calera',
    'La Cruz',
    'La Ligua',
    'Limache',
    'Llay-Llay',
    'Los Andes',
    'Nogales',
    'Olmué',
    'Panquehue',
    'Papudo',
    'Petorca',
    'Puchuncaví',
    'Putaendo',
    'Quillota',
    'Quilpué',
    'Quintero',
    'Rinconada',
    'San Antonio',
    'San Esteban',
    'San Felipe',
    'Santa María',
    'Santo Domingo',
    'Valparaíso',
    'Villa Alemana',
    'Viña del Mar',
    'Zapallar',
  ],
  'Región del Biobío': [
    'Alto Biobío',
    'Antuco',
    'Arauco',
    'Cabrero',
    'Cañete',
    'Chiguayante',
    'Concepción',
    'Contulmo',
    'Coronel',
    'Curanilahue',
    'Florida',
    'Hualpén',
    'Hualqui',
    'Laja',
    'Lebu',
    'Los Álamos',
    'Los Ángeles',
    'Lota',
    'Mulchén',
    'Nacimiento',
    'Negrete',
    'Penco',
    'Quilaco',
    'Quilleco',
    'San Pedro de La Paz',
    'San Rosendo',
    'Santa Bárbara',
    'Santa Juana',
    'Talcahuano',
    'Tirúa',
    'Tomé',
    'Tucapel',
    'Yumbel',
  ],
  "Región del Libertador General Bernardo O'Higgins": [
    'Chépica',
    'Chimbarongo',
    'Codegua',
    'Coinco',
    'Coltauco',
    'Doñihue',
    'Graneros',
    'La Estrella',
    'Las Cabras',
    'Litueche',
    'Lolol',
    'Machalí',
    'Malloa',
    'Marchihue',
    'Mostazal',
    'Nancagua',
    'Navidad',
    'Olivar',
    'Palmilla',
    'Paredones',
    'Peralillo',
    'Peumo',
    'Pichidegua',
    'Pichilemu',
    'Placilla',
    'Pumanque',
    'Quinta de Tilcoco',
    'Rancagua',
    'Rengo',
    'Requínoa',
    'San Fernando',
    'San Vicente',
    'Santa Cruz',
  ],
  'Región del Maule': [
    'Cauquenes',
    'Chanco',
    'Colbún',
    'Constitución',
    'Curepto',
    'Curicó',
    'Empedrado',
    'Hualañé',
    'Licantén',
    'Linares',
    'Longaví',
    'Maule',
    'Molina',
    'Parral',
    'Pelarco',
    'Pelluhue',
    'Pencahue',
    'Rauco',
    'Retiro',
    'Río Claro',
    'Romeral',
    'Sagrada Familia',
    'San Clemente',
    'San Javier',
    'San Rafael',
    'Talca',
    'Teno',
    'Vichuquén',
    'Villa Alegre',
    'Yerbas Buenas',
  ],
};

export const imageInstruction = {
  catThinkMobile: publicAsset('/cat_thinking_mobile.png'),
};

export const plansComparation = {
  heightOffDesktop: 208,
  heightOffMobile: 192,
};

export const separatorSplit = '|';

export const stepRoutePersonalInfo = 'nombre-apellido';
export const stepRouteEmail = 'correo-electronico';
export const stepRouteWorkers = 'numero-trabajadores';
export const stepRoutePlan = 'plan';
export const stepRouteCoverages = 'coberturas';
export const stepRouteQuoter = 'cotizador';
export const stepRouteVariants = 'cargas';
export const stepRouteForm = 'info-empresa';
export const stepRouteSummary = 'resumen';

export const leadOrigin = 'MIPYMESEGURA';
export const appTitle = 'Seguro Pyme | BICE VIDA';

export const dropdownAll = 'Todos';

export const incorporationStatusFilter: any = {
  ALL: dropdownAll,
  IN_PROCESS: 'En proceso',
  OUT_FOR_SIGNATURE: 'Por firmar',
  SIGNED: 'Firmado',
  HIRED: 'Cerrado',
};

export const panelListChunkLength = 8;

export const leadStatus = {
  ALL: 'Todos',
  ESTIMATION: 'Cotización',
  HIRING: 'Contratación',
  SIGNED: 'Firmado',
  HIRED: 'Cerrado',
};

export const leadManagerUser = {
  name: 'Deborah',
  img: ICON_USER,
};

export const loadOptions = {
  WITHOUT_LOADS: 'Sin cargas',
  ONE_LOAD: '1 carga',
  TWO_OR_MORE_LOADS: '2 cargas o más',
};

export const totalMonths = 12;

export const maxLengthString = 50;

export const rolesManager = {
  adminRole: 'admin',
  cognitoGroups: 'cognito:groups',
  isSupervisor: 'isSupervisor',
  isExecutiveMS: 'isExecutiveMS',
};

export const filterToday = 'Hoy';
export const filterLast7Days = 'Últimos 7 días';
export const filterLast14Days = 'Últimos 14 días';
export const filterLastMonth = 'Último mes';

export const COOKIE_EXPIRATION_DAYS = 5;

export const landingImageHero = [
  {
    src: publicAsset('/worker-1.png'),
    width: 432,
    height: 432,
    alt: 'Mujer de mediana edad apoyada en una pared sonriendo',
  },
  {
    src: publicAsset('/worker-2.png'),
    width: 432,
    height: 432,
    alt: 'Dos personas con pechera conversando frente a un computador',
  },
  {
    src: publicAsset('/worker-3.png'),
    width: 432,
    height: 432,
    alt: 'Un hombre con pechera mirando a su teléfono sonriendo',
  },
];

export const landingImageHeroIcons = [
  {
    src: HERO_ICON.NURSE,
    alt: 'ícono de una persona con corbata',
  },
  {
    src: HERO_ICON.SHIELD,
    alt: 'ícono de una cruz en un círculo verde',
  },
];

export const pillImage = publicAsset('/icon-cat-celebrating.png');

export const coveragesIcon = {
  ambulance: publicAsset('/icon-coverages-card-ambulance.png'),
  tooth: publicAsset('/icon-coverages-card-tooth.png'),
  heart: publicAsset('/icon-coverages-card-heart.png'),
  cross: publicAsset('/icon-coverages-card-cross.png'),
};

export const benefitsIcon = {
  phone: publicAsset('/icon-phone.png'),
  pills: publicAsset('/icon-pills.png'),
  todo: publicAsset('/icon-todo.png'),
  cross: publicAsset('/icon-cross.png'),
  pc: publicAsset('/icon-pc.png'),
};

export const quotationIcon = {
  watch: publicAsset('/icon-why-watch.png'),
  cup: publicAsset('/icon-why-cup.png'),
  laptop: publicAsset('/icon-why-laptop.png'),
};

export const whyChooseIcon = {
  domain: publicAsset('/icon-why-domain.svg'),
  union: publicAsset('/icon-why-union.svg'),
  place: publicAsset('/icon-why-location.svg'),
  people: publicAsset('/icon-why-people.svg'),
};

export const featuresIcon = {
  heart: publicAsset('/hero-icon-heart.png'),
  telemedicine: publicAsset('/features-icon-telemedicine.png'),
  cross: publicAsset('/features-icon-cross.png'),
  pills: publicAsset('/features-icon-pills.png'),
  notes: publicAsset('/features-icon-circle-notes.png'),
  money: publicAsset('/features-icon-money.png'),
  hospital: publicAsset('/features-icon-hospital.png'),
};

export const benefitsFeaturesIcon = {
  monitor: publicAsset('/benefits-features-monitor.png'),
  capsule: publicAsset('/benefits-features-capsule.png'),
  cross: publicAsset('/benefits-features-cross.png'),
  doctor: publicAsset('/benefits-features-doctor.png'),
  tennis: publicAsset('/benefits-features-tennis.png'),
  todo: publicAsset('/benefits-features-todo.png'),
  hospital: publicAsset('/benefits-features-hospital.png'),
};

export const iconCircle = publicAsset('/icon-circle.png');

export const assistancesImg = { pawer: publicAsset('/pawer_assistance.png') };

export const catGreetings = {
  png: publicAsset('/cat-greeting.png'),
  webp: publicAsset('/cat-greetings.webp'),
};

export const carouselSliderValues = {
  benefits: {
    steps: 3,
    cardsWidth: 718,
    cardsGap: 14,
  },

  benefitsRefund: {
    steps: 2,
    cardsWidth: 1024,
    btnDistance: 7,
  },
};

export const plansId: any = {
  standard: '5e4afcdbbc7b2e44b63dea55',
  standardDental: '5e4afcf3bc7b2e44b63dea59',
  standardCatastrophic: '5f871dfbffd98b7b3df51a88',
  standardDecease: '686e6bb5cbaccc9458d3d427',
};

export const DATE_FORMAT_STRUCTURE = 'EEE, d LLL yyyy';
export const DATE_FORMAT_FORM = 'dd/MM/yyyy';

export const INITIAL_DATE_MONTHS_TO_ADD = 12;
export const INITIAL_DATE_DAYS_TO_SUBTRACT = 1;

export const MAX_LENGTH_PHONE_NUMBER = 10;

export const EMAILS_TOP_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'yahoo.com',
  'outlook.com',
  'msn.com',
  'bice.cl',
];
export const DOMAINS_TO_SUGGESTION = ['com', 'cl'];

export enum StepsEnum {
  COMPANY_NAME = 'COMPANY_NAME',
  SHARE_INCORPORATION = 'SHARE_INCORPORATION',
  INCORPORATION_FORM = 'INCORPORATION_FORM',
  PYME_DATA = 'PYME_DATA',
  CHECK_INCORPORATION = 'CHECK_INCORPORATION',
  FINISH_HIRING = 'FINISH_HIRING',
}

export enum StatesEnum {
  DISABLE = 'DISABLE',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
}

export enum LeadStatusEnum {
  'HIRED' = 'HIRED',
  'PENDING' = 'PENDING',
  'CREATED' = 'CREATED',
}

export const CALL_CENTER_CODE = 'callcenter';

export const EMAIL_CODE_ACTION = {
  retrieve: 'retomar',
  confirm: 'confirmar',
};
export const MINIMUM_SIGNED = 5;

export const GRAPHQL_SESSION_EXPIRE_ERROR = 'GRAPHQL_SESSION_EXPIRE_ERROR';
export const GRAPHQL_PAYLOAD_ERROR = 'GRAPHQL_SESSION_EXPIRE_ERROR';
export const TIME_TO_EXPIRE = 60 * 60 * 24 * 5;

export const ranges = [
  { workers: 15, giftCardAmount: 200000 },
  { workers: 10, giftCardAmount: 150000 },
  { workers: 5, giftCardAmount: 100000 },
];

export enum OriginTypes {
  MIPYMESEGURA = 'MI_PYME_SEGURA',
  LEAD_MANAGER = 'LEAD_MANAGER',
  LINKEDIN = 'LINKEDIN',
  REFERRED = 'REFERRED',
  LINK_FACTORY = 'LINK_FACTORY',
  BANCO_BICE = 'BANCO_BICE',
}

export const benefitIcons = {
  pills: publicAsset('/benefit-icon-circle-pill.png'),
  heart: publicAsset('/benefit-icon-circle-heart.png'),
  health: publicAsset('/benefit-icon-circle-health.png'),
};

export const originList = [
  { description: 'Mi Pyme Segura', code: OriginTypes.MIPYMESEGURA },
  { description: 'Lead Manager', code: OriginTypes.LEAD_MANAGER },
  { description: 'Linkedin', code: OriginTypes.LINKEDIN },
  { description: 'Referido', code: OriginTypes.REFERRED },
  { description: 'Link Factor', code: OriginTypes.LINK_FACTORY },
  { description: 'BICE Corredores', code: OriginTypes.BANCO_BICE },
];

export const brandingCompanyHeroes = 'losheroes';

export const coverageItemTypes: { description: string; rowType: CoverageRow['rowType'] }[] = [
  { description: 'Cubre preexistencias', rowType: 'boolean' },
  { description: 'Bonificación general', rowType: 'percentage_maximum' },
  { description: 'Tope anual reembolsable', rowType: 'fixed' },
  { description: 'Seguro de vida', rowType: 'fixed' },
  { description: 'Medicamentos genéricos', rowType: 'text' },
  { description: 'Med. no genéricos', rowType: 'maximum' },
  { description: 'Psicología / Psiquiatría', rowType: 'maximum' },
  { description: 'Óptica', rowType: 'maximum' },
  { description: 'Cirugía Ocular', rowType: 'boolean' },
  { description: 'Deducible GES/CAEC/AUGE', rowType: 'fixed' },
  { description: 'Asistencia mascota', rowType: 'boolean' },
  { description: 'Deducible sin cargas', rowType: 'fixed' },
];

export const lastnameParticles = ['de', 'del', 'de la', 'la', 'los', 'las', 'san', 'santa'];
export const BLACK_LIST = 'test|prueba|1.111.111-1|99.999.999-9|1111111-1|99999999-9';

export const getRutsFrom1To9 = (): Array<{ withDots: string; withoutDots: string }> => {
  const ruts: Array<{ withDots: string; withoutDots: string }> = [];

  for (let digit = 0; digit <= 9; digit++) {
    const rutBase = digit.toString().repeat(8);
    const dv = digit;

    const withoutDots = `${rutBase}-${dv}`;
    const withDots = `${rutBase.slice(0, 2)}.${rutBase.slice(2, 5)}.${rutBase.slice(5, 8)}-${dv}`;
    ruts.push({ withDots, withoutDots });
  }

  return ruts;
};

const generateRutsBlackList = (): string => {
  const ruts = getRutsFrom1To9();
  const rutStrings = ruts.flatMap((rut) => [rut.withDots, rut.withoutDots]);

  return rutStrings.join('|');
};

export const BLACK_LIST_COMPANY_RUT = `12345678-9|12.345.678-9|${generateRutsBlackList()}`;
export const BLACK_LIST_NAMES =
  'test|prueba|caca|elcacas|lacaca|la caca|mierda|puta|puto|hdp|culiao|weon|wea|maricon|maricón|probando|123|panfilo|chanchitos|juan perez|juan pérez|patitos|:/';
export const variableOrder = ['dental', 'catastrofico', 'deceso'];
export const coverageName = ['Dental', 'Catastrófico', 'Deceso'];

export const kinshipList = ['Cónyuge/Conviviente civil', 'Hija', 'Hijo'];

export const monthList = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

export const diseaseList = [
  'Tumores (benignos o malignos)',
  'Cáncer',
  'Enfermedades de la sangre (anemias, leucemias, linfomas, etc.)',
  'Enfermedades endocrinas (diabetes, tiroides, etc.)',
  'Trastornos mentales y del comportamiento',
  'Enfermedades del sistema nervioso (epilepsia, esclerosis múltiple, etc.)',
  'Enfermedades del ojo (glaucoma, cataratas, etc.)',
  'Enfermedades del oído (hipoacusia, otitis crónica, etc.)',
  'Enfermedades del sistema circulatorio (hipertensión, arritmias, insuficiencia cardíaca, etc.)',
  'Enfermedades del sistema respiratorio (asma, EPOC, bronquitis crónica, etc.)',
  'Enfermedades del sistema digestivo (úlceras, cirrosis, colon irritable, etc.)',
  'Enfermedades de la piel (psoriasis, dermatitis crónica, etc.)',
  'Enfermedades del sistema osteomuscular (artritis, artrosis, hernias, escoliosis, etc.)',
  'Enfermedades del sistema genitourinario (insuficiencia renal, litiasis, etc.)',
  'Embarazo y puerperio',
  'Malformaciones congénitas',
  'Traumatismos y secuelas de accidentes',
  'Enfermedades infecciosas (VIH, hepatitis, tuberculosis, etc.)',
  'Obesidad y trastornos metabólicos',
  'Enfermedades autoinmunes (lupus, artritis reumatoide, etc.)',
  'Enfermedades hepáticas (hígado graso, hepatitis crónica, etc.)',
  'Trastornos de coagulación',
  'Enfermedades vasculares (varices, trombosis, etc.)',
  'Fibromialgia y síndrome de fatiga crónica',
  'Enfermedades de la columna vertebral',
  'Apnea del sueño',
  'Enfermedades del páncreas (pancreatitis crónica, etc.)',
  'Alergias crónicas severas',
  'Enfermedades neurológicas degenerativas (Parkinson, Alzheimer, etc.)',
  'Trastornos alimentarios (anorexia, bulimia)',
  'Síndrome de Down u otras alteraciones cromosómicas',
  'Otras enfermedades o condiciones no listadas',
];

export const countries = [
  'Chilena',
  'Argentina',
  'Boliviana',
  'Brasileña',
  'Afgana',
  'Albanesa',
  'Alemana',
  'Andorrana',
  'Angoleña',
  'Antiguana',
  'Argelina',
  'Armenia',
  'Australiana',
  'Austriaca',
  'Azerbaiyana',
  'Bahameña',
  'Bangladesí',
  'Barbadense',
  'Bareiní',
  'Belga',
  'Beliceña',
  'Beninesa',
  'Bielorrusa',
  'Birmana',
  'Bosnia',
  'Botsuana',
  'Brasileño',
  'Bruneana',
  'Búlgara',
  'Burkinesa',
  'Burundesa',
  'Butanesa',
  'Caboverdiana',
  'Camboyana',
  'Camerunesa',
  'Canadiense',
  'Catarí',
  'Chadiana',
  'China',
  'Chipriota',
  'Checa',
  'Colombiana',
  'Comorense',
  'Congoleña',
  'Congoleño',
  'Costarricense',
  'Croata',
  'Cristobaleña',
  'Cubana',
  'Danesa',
  'Dominiquesa',
  'Ecuatoriana',
  'Egipcia',
  'Emiratí',
  'Eritrea',
  'Eslovaca',
  'Eslovena',
  'Española',
  'Estadounidense',
  'Estonia',
  'Etíope',
  'Fiyiana',
  'Filipina',
  'Finlandesa',
  'Francesa',
  'Gabonesa',
  'Gambiana',
  'Georgiana',
  'Ghanesa',
  'Granadina',
  'Griega',
  'Guatemalteca',
  'Guineana',
  'Guyanesa',
  'Haitiana',
  'Hondureña',
  'Húngara',
  'India',
  'Indonesia',
  'Iraní',
  'Irlandesa',
  'Islandesa',
  'Israelí',
  'Italiana',
  'Jamaicana',
  'Japonesa',
  'Jordana',
  'Kazaja',
  'Keniana',
  'Kirguisa',
  'Kiribatiana',
  'Kuwaití',
  'Laosiana',
  'Lesotense',
  'Letona',
  'Libanesa',
  'Liberiana',
  'Libio',
  'Liechtensteiniana',
  'Lituana',
  'Luxemburguesa',
  'Macedonia',
  'Malayo',
  'Malaui',
  'Maldiva',
  'Maliense',
  'Malí',
  'Maltesa',
  'Marfileña',
  'Marroquí',
  'Mauriciana',
  'Mauritana',
  'Mexicana',
  'Micronesia',
  'Moldava',
  'Monegasca',
  'Mongola',
  'Montenegrina',
  'Mozambiqueña',
  'Namibia',
  'Nauruana',
  'Neerlandesa',
  'Nepalí',
  'Nicaragüense',
  'Nigerina',
  'Norcoreana',
  'Noruega',
  'Neozelandesa',
  'Omaní',
  'Pakistaní',
  'Palauana',
  'Panameña',
  'Papúa',
  'Paraguaya',
  'Peruana',
  'Polaca',
  'Portuguesa',
  'Reino Unido',
  'Ruandesa',
  'Rumana',
  'Rusa',
  'Salomónica',
  'Salvadoreña',
  'Samoana',
  'Sanmarinense',
  'Sanvicentina',
  'Santolucense',
  'Santomense',
  'Saudí',
  'Senegalesa',
  'Serbia',
  'Seychellense',
  'Sierraleonesa',
  'Singapurense',
  'Siria',
  'Somalí',
  'Sudanesa',
  'Sudafricana',
  'Surcoreana',
  'Surinamesa',
  'Sursudanesa',
  'Suazi',
  'Sueca',
  'Suiza',
  'Tailandesa',
  'Tanzana',
  'Tayika',
  'Timorense',
  'Togolesa',
  'Tongana',
  'Trinitense',
  'Tunecina',
  'Turca',
  'Turcomana',
  'Tuvaluana',
  'Ucraniana',
  'Ugandesa',
  'Uruguaya',
  'Uzbeka',
  'Vanuatense',
  'Venezolana',
  'Vietnamita',
  'Yemení',
  'Yibutí',
  'Zambiana',
  'Zimbabuense',
];
